/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.27.1
// source: scavenger.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.proto = require('./scavenger_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.ScavengerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.ScavengerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndDates,
 *   !proto.proto.OverviewDataList>}
 */
const methodDescriptor_ScavengerService_GetScavengerOverview = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerOverview',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceIdAndDates,
  proto.proto.OverviewDataList,
  /**
   * @param {!proto.proto.DeviceIdAndDates} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.OverviewDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.OverviewDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.OverviewDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerOverview =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerOverview',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerOverview,
      callback);
};


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.OverviewDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerOverview =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerOverview',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerOverview);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceId,
 *   !proto.proto.OverviewData>}
 */
const methodDescriptor_ScavengerService_GetScavengerOverviewStream = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerOverviewStream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.proto.DeviceId,
  proto.proto.OverviewData,
  /**
   * @param {!proto.proto.DeviceId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.OverviewData.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceId} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.OverviewData>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerOverviewStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerOverviewStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerOverviewStream);
};


/**
 * @param {!proto.proto.DeviceId} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.OverviewData>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerOverviewStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerOverviewStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerOverviewStream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndDates,
 *   !proto.proto.Device>}
 */
const methodDescriptor_ScavengerService_GetScavengerData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceIdAndDates,
  proto.proto.Device,
  /**
   * @param {!proto.proto.DeviceIdAndDates} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Device.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerData,
      callback);
};


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Device>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.Device>}
 */
const methodDescriptor_ScavengerService_GetScavengerList = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerList',
  grpc.web.MethodType.UNARY,
  proto.proto.Empty,
  proto.proto.Device,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Device.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerList',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerList,
      callback);
};


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Device>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerList',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AggPeriod,
 *   !proto.proto.Device>}
 */
const methodDescriptor_ScavengerService_GetScavengerListStream = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerListStream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.proto.AggPeriod,
  proto.proto.Device,
  /**
   * @param {!proto.proto.AggPeriod} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Device.deserializeBinary
);


/**
 * @param {!proto.proto.AggPeriod} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Device>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerListStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerListStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerListStream);
};


/**
 * @param {!proto.proto.AggPeriod} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Device>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerListStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerListStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerListStream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.DeviceList>}
 */
const methodDescriptor_ScavengerService_GetScvDeviceList = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScvDeviceList',
  grpc.web.MethodType.UNARY,
  proto.proto.Empty,
  proto.proto.DeviceList,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DeviceList.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DeviceList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DeviceList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScvDeviceList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScvDeviceList',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvDeviceList,
      callback);
};


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DeviceList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScvDeviceList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScvDeviceList',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvDeviceList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndchartdata,
 *   !proto.proto.ChartDataList>}
 */
const methodDescriptor_ScavengerService_GetScavengerChartData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerChartData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceIdAndchartdata,
  proto.proto.ChartDataList,
  /**
   * @param {!proto.proto.DeviceIdAndchartdata} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ChartDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndchartdata} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ChartDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ChartDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerChartData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerChartData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerChartData,
      callback);
};


/**
 * @param {!proto.proto.DeviceIdAndchartdata} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ChartDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerChartData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerChartData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerChartData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndDates,
 *   !proto.proto.ChartData>}
 */
const methodDescriptor_ScavengerService_GetScavengerChartDataStream = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerChartDataStream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.proto.DeviceIdAndDates,
  proto.proto.ChartData,
  /**
   * @param {!proto.proto.DeviceIdAndDates} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ChartData.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndDates} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ChartData>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerChartDataStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerChartDataStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerChartDataStream);
};


/**
 * @param {!proto.proto.DeviceIdAndDates} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ChartData>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerChartDataStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerChartDataStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerChartDataStream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndDates,
 *   !proto.proto.MinDataList>}
 */
const methodDescriptor_ScavengerService_GetMinListData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetMinListData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceIdAndDates,
  proto.proto.MinDataList,
  /**
   * @param {!proto.proto.DeviceIdAndDates} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.MinDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.MinDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.MinDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getMinListData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetMinListData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetMinListData,
      callback);
};


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.MinDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getMinListData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetMinListData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetMinListData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Duration,
 *   !proto.proto.DevOverviewDataList>}
 */
const methodDescriptor_ScavengerService_GetScavengerDevOverview = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerDevOverview',
  grpc.web.MethodType.UNARY,
  proto.proto.Duration,
  proto.proto.DevOverviewDataList,
  /**
   * @param {!proto.proto.Duration} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DevOverviewDataList.deserializeBinary
);


/**
 * @param {!proto.proto.Duration} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DevOverviewDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DevOverviewDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerDevOverview =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerDevOverview',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerDevOverview,
      callback);
};


/**
 * @param {!proto.proto.Duration} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DevOverviewDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerDevOverview =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerDevOverview',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerDevOverview);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndDates,
 *   !proto.proto.BoxChartDataList>}
 */
const methodDescriptor_ScavengerService_GetScavengerBoxchartData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerBoxchartData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceIdAndDates,
  proto.proto.BoxChartDataList,
  /**
   * @param {!proto.proto.DeviceIdAndDates} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.BoxChartDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.BoxChartDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.BoxChartDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerBoxchartData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerBoxchartData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerBoxchartData,
      callback);
};


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.BoxChartDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerBoxchartData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerBoxchartData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerBoxchartData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndchartdata,
 *   !proto.proto.CustomDataList>}
 */
const methodDescriptor_ScavengerService_GetScavengerTrendsData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerTrendsData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceIdAndchartdata,
  proto.proto.CustomDataList,
  /**
   * @param {!proto.proto.DeviceIdAndchartdata} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CustomDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndchartdata} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CustomDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CustomDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerTrendsData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerTrendsData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerTrendsData,
      callback);
};


/**
 * @param {!proto.proto.DeviceIdAndchartdata} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CustomDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerTrendsData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerTrendsData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerTrendsData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceIdAndDates,
 *   !proto.proto.VoltageDataList>}
 */
const methodDescriptor_ScavengerService_GetScavengerVoltageData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerVoltageData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceIdAndDates,
  proto.proto.VoltageDataList,
  /**
   * @param {!proto.proto.DeviceIdAndDates} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.VoltageDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.VoltageDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.VoltageDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerVoltageData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerVoltageData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerVoltageData,
      callback);
};


/**
 * @param {!proto.proto.DeviceIdAndDates} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.VoltageDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerVoltageData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerVoltageData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerVoltageData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceId,
 *   !proto.proto.AccPowerDataList>}
 */
const methodDescriptor_ScavengerService_GetAccumulatedPowerData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetAccumulatedPowerData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceId,
  proto.proto.AccPowerDataList,
  /**
   * @param {!proto.proto.DeviceId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.AccPowerDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.AccPowerDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.AccPowerDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getAccumulatedPowerData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetAccumulatedPowerData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetAccumulatedPowerData,
      callback);
};


/**
 * @param {!proto.proto.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.AccPowerDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getAccumulatedPowerData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetAccumulatedPowerData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetAccumulatedPowerData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceId,
 *   !proto.proto.EnrgyMtrDataList>}
 */
const methodDescriptor_ScavengerService_GetEnrgyMtrData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetEnrgyMtrData',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceId,
  proto.proto.EnrgyMtrDataList,
  /**
   * @param {!proto.proto.DeviceId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.EnrgyMtrDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.EnrgyMtrDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.EnrgyMtrDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getEnrgyMtrData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetEnrgyMtrData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetEnrgyMtrData,
      callback);
};


/**
 * @param {!proto.proto.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.EnrgyMtrDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getEnrgyMtrData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetEnrgyMtrData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetEnrgyMtrData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DurationAndPlannerGroup,
 *   !proto.proto.ScvDonutDataList>}
 */
const methodDescriptor_ScavengerService_GetScvDonutData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScvDonutData',
  grpc.web.MethodType.UNARY,
  proto.proto.DurationAndPlannerGroup,
  proto.proto.ScvDonutDataList,
  /**
   * @param {!proto.proto.DurationAndPlannerGroup} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ScvDonutDataList.deserializeBinary
);


/**
 * @param {!proto.proto.DurationAndPlannerGroup} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ScvDonutDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ScvDonutDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScvDonutData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScvDonutData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvDonutData,
      callback);
};


/**
 * @param {!proto.proto.DurationAndPlannerGroup} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ScvDonutDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScvDonutData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScvDonutData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvDonutData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Duration,
 *   !proto.proto.ScvCapacityDonutDataList>}
 */
const methodDescriptor_ScavengerService_GetScvCapacityDonutData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScvCapacityDonutData',
  grpc.web.MethodType.UNARY,
  proto.proto.Duration,
  proto.proto.ScvCapacityDonutDataList,
  /**
   * @param {!proto.proto.Duration} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ScvCapacityDonutDataList.deserializeBinary
);


/**
 * @param {!proto.proto.Duration} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ScvCapacityDonutDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ScvCapacityDonutDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScvCapacityDonutData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScvCapacityDonutData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvCapacityDonutData,
      callback);
};


/**
 * @param {!proto.proto.Duration} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ScvCapacityDonutDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScvCapacityDonutData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScvCapacityDonutData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvCapacityDonutData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ScavengerReportFields,
 *   !proto.proto.ScavengerAvailableReportDatesList>}
 */
const methodDescriptor_ScavengerService_GetScavengerAvailableReportDates = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerAvailableReportDates',
  grpc.web.MethodType.UNARY,
  proto.proto.ScavengerReportFields,
  proto.proto.ScavengerAvailableReportDatesList,
  /**
   * @param {!proto.proto.ScavengerReportFields} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ScavengerAvailableReportDatesList.deserializeBinary
);


/**
 * @param {!proto.proto.ScavengerReportFields} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ScavengerAvailableReportDatesList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ScavengerAvailableReportDatesList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerAvailableReportDates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerAvailableReportDates',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerAvailableReportDates,
      callback);
};


/**
 * @param {!proto.proto.ScavengerReportFields} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ScavengerAvailableReportDatesList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerAvailableReportDates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScavengerAvailableReportDates',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerAvailableReportDates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ScavengerReportFields,
 *   !proto.proto.En50160ReportList>}
 */
const methodDescriptor_ScavengerService_GetEn50160Report = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetEn50160Report',
  grpc.web.MethodType.UNARY,
  proto.proto.ScavengerReportFields,
  proto.proto.En50160ReportList,
  /**
   * @param {!proto.proto.ScavengerReportFields} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.En50160ReportList.deserializeBinary
);


/**
 * @param {!proto.proto.ScavengerReportFields} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.En50160ReportList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.En50160ReportList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getEn50160Report =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetEn50160Report',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetEn50160Report,
      callback);
};


/**
 * @param {!proto.proto.ScavengerReportFields} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.En50160ReportList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getEn50160Report =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetEn50160Report',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetEn50160Report);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeviceId,
 *   !proto.proto.TempSensorInfoList>}
 */
const methodDescriptor_ScavengerService_GetTempSensorInfo = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetTempSensorInfo',
  grpc.web.MethodType.UNARY,
  proto.proto.DeviceId,
  proto.proto.TempSensorInfoList,
  /**
   * @param {!proto.proto.DeviceId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.TempSensorInfoList.deserializeBinary
);


/**
 * @param {!proto.proto.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.TempSensorInfoList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.TempSensorInfoList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getTempSensorInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetTempSensorInfo',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetTempSensorInfo,
      callback);
};


/**
 * @param {!proto.proto.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.TempSensorInfoList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getTempSensorInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetTempSensorInfo',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetTempSensorInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.ScvReportDataList>}
 */
const methodDescriptor_ScavengerService_GetScvReportData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScvReportData',
  grpc.web.MethodType.UNARY,
  proto.proto.Empty,
  proto.proto.ScvReportDataList,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ScvReportDataList.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ScvReportDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ScvReportDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScvReportData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetScvReportData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvReportData,
      callback);
};


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ScvReportDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScvReportData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetScvReportData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScvReportData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.InstalledDevicesReportDataList>}
 */
const methodDescriptor_ScavengerService_GetInstalledDevicesReportData = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetInstalledDevicesReportData',
  grpc.web.MethodType.UNARY,
  proto.proto.Empty,
  proto.proto.InstalledDevicesReportDataList,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.InstalledDevicesReportDataList.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.InstalledDevicesReportDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.InstalledDevicesReportDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getInstalledDevicesReportData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.ScavengerService/GetInstalledDevicesReportData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetInstalledDevicesReportData,
      callback);
};


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.InstalledDevicesReportDataList>}
 *     Promise that resolves to the response
 */
proto.proto.ScavengerServicePromiseClient.prototype.getInstalledDevicesReportData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.ScavengerService/GetInstalledDevicesReportData',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetInstalledDevicesReportData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AssetPayload,
 *   !proto.proto.AssetDataList>}
 */
const methodDescriptor_ScavengerService_GetScavengerAssetDataStream = new grpc.web.MethodDescriptor(
  '/proto.ScavengerService/GetScavengerAssetDataStream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.proto.AssetPayload,
  proto.proto.AssetDataList,
  /**
   * @param {!proto.proto.AssetPayload} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.AssetDataList.deserializeBinary
);


/**
 * @param {!proto.proto.AssetPayload} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.AssetDataList>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServiceClient.prototype.getScavengerAssetDataStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerAssetDataStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerAssetDataStream);
};


/**
 * @param {!proto.proto.AssetPayload} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.AssetDataList>}
 *     The XHR Node Readable Stream
 */
proto.proto.ScavengerServicePromiseClient.prototype.getScavengerAssetDataStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.ScavengerService/GetScavengerAssetDataStream',
      request,
      metadata || {},
      methodDescriptor_ScavengerService_GetScavengerAssetDataStream);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.AlertServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.AlertServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.AlertDataList>}
 */
const methodDescriptor_AlertService_GetScvAlertsData = new grpc.web.MethodDescriptor(
  '/proto.AlertService/GetScvAlertsData',
  grpc.web.MethodType.UNARY,
  proto.proto.Empty,
  proto.proto.AlertDataList,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.AlertDataList.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.AlertDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.AlertDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.AlertServiceClient.prototype.getScvAlertsData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.AlertService/GetScvAlertsData',
      request,
      metadata || {},
      methodDescriptor_AlertService_GetScvAlertsData,
      callback);
};


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.AlertDataList>}
 *     Promise that resolves to the response
 */
proto.proto.AlertServicePromiseClient.prototype.getScvAlertsData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.AlertService/GetScvAlertsData',
      request,
      metadata || {},
      methodDescriptor_AlertService_GetScvAlertsData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.ActiveAlertsList>}
 */
const methodDescriptor_AlertService_GetScvActiveAlerts = new grpc.web.MethodDescriptor(
  '/proto.AlertService/GetScvActiveAlerts',
  grpc.web.MethodType.UNARY,
  proto.proto.Empty,
  proto.proto.ActiveAlertsList,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ActiveAlertsList.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ActiveAlertsList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ActiveAlertsList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.AlertServiceClient.prototype.getScvActiveAlerts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.AlertService/GetScvActiveAlerts',
      request,
      metadata || {},
      methodDescriptor_AlertService_GetScvActiveAlerts,
      callback);
};


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ActiveAlertsList>}
 *     Promise that resolves to the response
 */
proto.proto.AlertServicePromiseClient.prototype.getScvActiveAlerts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.AlertService/GetScvActiveAlerts',
      request,
      metadata || {},
      methodDescriptor_AlertService_GetScvActiveAlerts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AlertPayload,
 *   !proto.proto.Status>}
 */
const methodDescriptor_AlertService_AddScvAlert = new grpc.web.MethodDescriptor(
  '/proto.AlertService/AddScvAlert',
  grpc.web.MethodType.UNARY,
  proto.proto.AlertPayload,
  proto.proto.Status,
  /**
   * @param {!proto.proto.AlertPayload} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Status.deserializeBinary
);


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Status)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Status>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.AlertServiceClient.prototype.addScvAlert =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.AlertService/AddScvAlert',
      request,
      metadata || {},
      methodDescriptor_AlertService_AddScvAlert,
      callback);
};


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Status>}
 *     Promise that resolves to the response
 */
proto.proto.AlertServicePromiseClient.prototype.addScvAlert =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.AlertService/AddScvAlert',
      request,
      metadata || {},
      methodDescriptor_AlertService_AddScvAlert);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AlertPayload,
 *   !proto.proto.Status>}
 */
const methodDescriptor_AlertService_UpdateScvAlert = new grpc.web.MethodDescriptor(
  '/proto.AlertService/UpdateScvAlert',
  grpc.web.MethodType.UNARY,
  proto.proto.AlertPayload,
  proto.proto.Status,
  /**
   * @param {!proto.proto.AlertPayload} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Status.deserializeBinary
);


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Status)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Status>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.AlertServiceClient.prototype.updateScvAlert =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.AlertService/UpdateScvAlert',
      request,
      metadata || {},
      methodDescriptor_AlertService_UpdateScvAlert,
      callback);
};


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Status>}
 *     Promise that resolves to the response
 */
proto.proto.AlertServicePromiseClient.prototype.updateScvAlert =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.AlertService/UpdateScvAlert',
      request,
      metadata || {},
      methodDescriptor_AlertService_UpdateScvAlert);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AlertPayload,
 *   !proto.proto.Status>}
 */
const methodDescriptor_AlertService_DeleteScvAlert = new grpc.web.MethodDescriptor(
  '/proto.AlertService/DeleteScvAlert',
  grpc.web.MethodType.UNARY,
  proto.proto.AlertPayload,
  proto.proto.Status,
  /**
   * @param {!proto.proto.AlertPayload} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Status.deserializeBinary
);


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Status)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Status>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.AlertServiceClient.prototype.deleteScvAlert =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.AlertService/DeleteScvAlert',
      request,
      metadata || {},
      methodDescriptor_AlertService_DeleteScvAlert,
      callback);
};


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Status>}
 *     Promise that resolves to the response
 */
proto.proto.AlertServicePromiseClient.prototype.deleteScvAlert =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.AlertService/DeleteScvAlert',
      request,
      metadata || {},
      methodDescriptor_AlertService_DeleteScvAlert);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AlertPayload,
 *   !proto.proto.ScvRecipientsList>}
 */
const methodDescriptor_AlertService_GetScvRecipientsList = new grpc.web.MethodDescriptor(
  '/proto.AlertService/GetScvRecipientsList',
  grpc.web.MethodType.UNARY,
  proto.proto.AlertPayload,
  proto.proto.ScvRecipientsList,
  /**
   * @param {!proto.proto.AlertPayload} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ScvRecipientsList.deserializeBinary
);


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ScvRecipientsList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ScvRecipientsList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.AlertServiceClient.prototype.getScvRecipientsList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.AlertService/GetScvRecipientsList',
      request,
      metadata || {},
      methodDescriptor_AlertService_GetScvRecipientsList,
      callback);
};


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ScvRecipientsList>}
 *     Promise that resolves to the response
 */
proto.proto.AlertServicePromiseClient.prototype.getScvRecipientsList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.AlertService/GetScvRecipientsList',
      request,
      metadata || {},
      methodDescriptor_AlertService_GetScvRecipientsList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.AlertPayload,
 *   !proto.proto.Status>}
 */
const methodDescriptor_AlertService_AddScvRecipient = new grpc.web.MethodDescriptor(
  '/proto.AlertService/AddScvRecipient',
  grpc.web.MethodType.UNARY,
  proto.proto.AlertPayload,
  proto.proto.Status,
  /**
   * @param {!proto.proto.AlertPayload} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.Status.deserializeBinary
);


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.Status)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.Status>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.AlertServiceClient.prototype.addScvRecipient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.AlertService/AddScvRecipient',
      request,
      metadata || {},
      methodDescriptor_AlertService_AddScvRecipient,
      callback);
};


/**
 * @param {!proto.proto.AlertPayload} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.Status>}
 *     Promise that resolves to the response
 */
proto.proto.AlertServicePromiseClient.prototype.addScvRecipient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.AlertService/AddScvRecipient',
      request,
      metadata || {},
      methodDescriptor_AlertService_AddScvRecipient);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.MobileServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.MobileServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.SitesDataList>}
 */
const methodDescriptor_MobileService_GetSites = new grpc.web.MethodDescriptor(
  '/proto.MobileService/GetSites',
  grpc.web.MethodType.UNARY,
  proto.proto.Empty,
  proto.proto.SitesDataList,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.SitesDataList.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.SitesDataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.SitesDataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.MobileServiceClient.prototype.getSites =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.MobileService/GetSites',
      request,
      metadata || {},
      methodDescriptor_MobileService_GetSites,
      callback);
};


/**
 * @param {!proto.proto.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.SitesDataList>}
 *     Promise that resolves to the response
 */
proto.proto.MobileServicePromiseClient.prototype.getSites =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.MobileService/GetSites',
      request,
      metadata || {},
      methodDescriptor_MobileService_GetSites);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.NotificationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.NotificationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.EventStream>}
 */
const methodDescriptor_NotificationService_GetScvRealTimeEvents = new grpc.web.MethodDescriptor(
  '/proto.NotificationService/GetScvRealTimeEvents',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.proto.Empty,
  proto.proto.EventStream,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.EventStream.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.EventStream>}
 *     The XHR Node Readable Stream
 */
proto.proto.NotificationServiceClient.prototype.getScvRealTimeEvents =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.NotificationService/GetScvRealTimeEvents',
      request,
      metadata || {},
      methodDescriptor_NotificationService_GetScvRealTimeEvents);
};


/**
 * @param {!proto.proto.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.EventStream>}
 *     The XHR Node Readable Stream
 */
proto.proto.NotificationServicePromiseClient.prototype.getScvRealTimeEvents =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.NotificationService/GetScvRealTimeEvents',
      request,
      metadata || {},
      methodDescriptor_NotificationService_GetScvRealTimeEvents);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Empty,
 *   !proto.proto.AlertStream>}
 */
const methodDescriptor_NotificationService_GetScvRealTimeAlerts = new grpc.web.MethodDescriptor(
  '/proto.NotificationService/GetScvRealTimeAlerts',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.proto.Empty,
  proto.proto.AlertStream,
  /**
   * @param {!proto.proto.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.AlertStream.deserializeBinary
);


/**
 * @param {!proto.proto.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.AlertStream>}
 *     The XHR Node Readable Stream
 */
proto.proto.NotificationServiceClient.prototype.getScvRealTimeAlerts =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.NotificationService/GetScvRealTimeAlerts',
      request,
      metadata || {},
      methodDescriptor_NotificationService_GetScvRealTimeAlerts);
};


/**
 * @param {!proto.proto.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.proto.AlertStream>}
 *     The XHR Node Readable Stream
 */
proto.proto.NotificationServicePromiseClient.prototype.getScvRealTimeAlerts =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/proto.NotificationService/GetScvRealTimeAlerts',
      request,
      metadata || {},
      methodDescriptor_NotificationService_GetScvRealTimeAlerts);
};


export default proto.proto;

